var e;!function(e){e.VIDEO="video",e.THREE_SIXTY="three_sixty"}(e||(e={}));export{e as IconType};
